import React, { useContext } from 'react'

import { DataContext } from '../../DataContext'
import Assignment from './Assignment'
import FacilityAssignmentContextProvider from './DataContext'
import PanelStyleContextProvider from '../../../../elem/panel/PanelStyleContext'
import FacilityFilter from './FacilityFilter'

import Panel from '../../../../elem/panel/Panel'
import { wellPanel } from '../../../../../utils/styles/panelStyles'

import DataContextProvider from '../../../explorer/map/DataContext'
import MapControlContextProvider from '../../../explorer/map/MapControlContext'
import { mapPanel as panelClassConfig } from '../../../../../utils/styles/panelStyles'
import ViewMapMerge from '../viewMapTab/ViewMapMerge'

const FacilityAssignment = () => {
    const { activePanel, viewOnly } = useContext(DataContext)
    return (
        <FacilityAssignmentContextProvider>
            <div
                className={`columns is-multiline
                ${activePanel !== 'Filter Wells' ? 'is-hidden' : ''}
            `}
            >
                <PanelStyleContextProvider panelClassConfig={{}}>
                    {!viewOnly && <FacilityFilter />}
                </PanelStyleContextProvider>
                <div className="column is-12 assignmentPanel">
                    <Panel panelClassConfig={wellPanel('full')}>
                        <Assignment />
                    </Panel>
                </div>
            </div>
            <DataContextProvider>
                <MapControlContextProvider mapMenu={`SubmissionsMap`}>
                    <Panel panelClassConfig={panelClassConfig(12)}>
                        <ViewMapMerge />
                    </Panel>
                </MapControlContextProvider>
            </DataContextProvider>
        </FacilityAssignmentContextProvider>
    )
}

export default FacilityAssignment
